import Router from 'live/services/router'
import i18n from 'live/services/i18n'
import SettingsService from 'live/services/settings'
import pt_br from './i18n/pt_br'
import en_us from './i18n/en_us'
import Uploads from './components/Uploads'
import './integration-sftp/init'
import './integration-s3/init'
import FeatureFlags from "./features/feature-flags";

const isLoggedIn = Object.keys(Live.currentUser).length !== 0

var locale = (Live.settings && Live.settings.locale) ? Live.settings.locale : 'pt_br';
var localeFiles = {
    pt_br: pt_br,
    en_us: en_us
};

i18n.add(localeFiles[locale]);

if (isLoggedIn) {
    const uploadsConfig = {
        name: 'Uploads',
        url: '#/Uploads',
        alias: 'Uploads',
        ico: 'fas fa-upload',
        position: 'first-block',
        addRoute: false,
        routeUrl: null,
        component: null
    }

    try {
        const ExtensionService = require('live/services/extension')
        Router.route('/Uploads', Uploads, 'Uploads')
        ExtensionService.addAdminMenu(uploadsConfig)
    } catch (e) {
        console.error("Error creating Upload item. " + e.message, e)
    }

}

SettingsService.register(FeatureFlags)
